import { propertyManagingAgentCard } from '../../shared';
import type { OfferLocaleOverrides } from '../base';
import {
  buyersAttorneyContactCard,
  sellersAttorneyContactCard,
} from '../cards';

export const NYOverrides: OfferLocaleOverrides = {
  locale: 'NY',
  sections: {
    buySideContacts: {
      cards: {
        buyersAgentCard: {
          fields: {
            licenseNumber: {
              disabledForIndex: -1,
            },
          },
        },
        buyersAttorneyContactCard,
      },
    },
    sellerSideContacts: {
      cards: {
        sellersAttorneyContactCard,
      },
    },
    additionalContacts: {
      cards: {
        titleOfficerContactCard: null,
        attorneyContactCard: () => propertyManagingAgentCard,
        addAdditionalContactCard: {
          fields: {
            newContact: {
              options: (options) => [
                {
                  label: 'Property Managing Agent',
                  value: 'additionalContacts.propertyManagingAgent',
                },
                ...options.slice(1),
              ],
            },
          },
        },
      },
    },
  },
};
